// extracted by mini-css-extract-plugin
export default {"root":"MaskedDiv_root__XMHpo","border":"MaskedDiv_border__SXLoE","active":"MaskedDiv_active__OqQdU"};